module.exports = __webpack_public_path__ + "img/IMG_9786_L_Black.7deda126.jpg";